import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@abg/ui/index.css'
import './styles/app.css'
import { App } from './App'
import { AuthProvider } from './lib/auth'

/**
 * Service worker registration.
 *
 * Deferred to `load` so it never competes with the first paint, and skipped
 * entirely in development -- a stale service worker caching a dev bundle is a
 * genuinely confusing hour to debug, and `vite dev` already serves fresh.
 *
 * On finding a new worker we do NOT auto-reload. A captain mid-way through an
 * application form does not want the page replaced under them; the update is
 * applied on the next cold start, which for an installed PWA is soon enough.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
